import React, { useState } from 'react';

export const ScrollContext = React.createContext();

export const ScrollProvider = ({ children }) => {
    const [ scrollPosition, setScrollPosition ] = useState(0);

    return (
        <ScrollContext.Provider value={{ 
            scrollPosition, setScrollPosition
         }}>
             {children}
        </ScrollContext.Provider>
    );
};
